import React from 'react';
import { Col, Row, Typography, Alert } from 'antd';
import IconSend from '../../images/icon-send.svg';

const { Title } = Typography;

const SuccessDemur = () => {

  return (
    <div className="text-center">
      <Row className="mb-4">
        <Col md={14} lg={10} className="mx-auto">
          <img src={IconSend} alt="" className="mb-4 d-block mx-auto" />
          <Title level={2}>Tu objeción fue enviada con éxito</Title>
          <Alert description="Para tu tranquilidad se anuló el contrato actual para crear una nueva versión de este." />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={12} lg={10} className="text-center mx-auto">
          <p>Una vez aceptado por el creador se te enviará nuevamente un mail para realizar el proceso de revisión y posterior  firma de nuevo contrato de arriendo.</p>
        </Col>
      </Row>
    </div>
  );
};

export default SuccessDemur;